module.exports = __webpack_public_path__ + "static/media/Check.7c4fa72b.svg";